












import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class ComponentSeloProtocolo extends Vue {
  @Prop({ default: 'aceito' })
  readonly status: 'aceito' | 'recusado';

  @Prop({ default: 48 })
  readonly size: number | string;

  get circleColor(): string {
    return this.status === 'aceito' ? '#008000' : '#C62828'
  }
}
